export default __webpack_public_path__ + "static/media/blast.c38ab25f.mpeg";